var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    d: "M94.2,19.9L80.1,5.8l5.7-5.7l14.1,14.1L94.2,19.9z M78.5,21.4C61.5,4.4,34.7,3.5,16.6,18.5L28,25 c13.1-8.2,30.6-6.6,42,4.8c13.3,13.3,13.3,34.8,0,48.1c-11.4,11.4-28.9,13-42,4.8l-11.4,6.6c18.1,15,44.9,14.1,61.9-2.9 C96.5,68.5,96.5,39.3,78.5,21.4z M50,52.3V32h-8v23.6l16.7,16.7l5.6-5.7L50,52.3z M14.7,67.3l-10.5,6c1.1,2.4,2.5,4.7,4,6.9l10.4-6 C17.1,72.1,15.8,69.7,14.7,67.3z M12,55c0-0.7,0-1.5,0-2.3c0-1,0.1-1.9,0.2-2.9l-12.1,0c-0.2,2.7-0.2,5.3,0,8l12.1,0 C12.1,57,12,56,12,55z M18.7,33.6l-10.4-6c-1.6,2.2-2.9,4.5-4,6.9l10.5,6C15.8,38.1,17.1,35.7,18.7,33.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon12);
export default __webpack_public_path__ + "static/media/motion_icon-12.7f8b57f4.svg";
export { ForwardRef as ReactComponent };